import { Modal, Button } from 'antd'

import Close from '../../svgs/CloseModal'

const Popup = ({
  type,
  open,
  setOpen,
  title,
  subTitle,
  confirmTitle,
  loading,
  onDelete,
}) => {
  return (
    <Modal
      className='!w-[30rem]'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
    >
      <div className='text-center mb-40 mt-16'>
        <h3 className='text-xl font-semibold mb-16 w-10/12 mx-auto'>{title}</h3>
        <p className='text-dimmed text-sm leading-6'>{subTitle}</p>
      </div>

      <div className='flex justify-center gap-4 mb-16'>
        <Button
          className='!text-black hover:text-white text-base font-semibold border-0 py-12 px-24 h-auto shadow-0'
          onClick={() => setOpen(false)}
        >
          Cancella
        </Button>
        <Button
          className={`${
            type === 'danger' ? 'bg-danger' : ''
          } !text-white text-base font-semibold border-0 py-12 px-24 h-auto`}
          loading={loading}
          onClick={onDelete}
        >
          {confirmTitle}
        </Button>
      </div>

      <Close
        style='absolute top-24 right-24 w-24 cursor-pointer'
        onClick={() => setOpen(false)}
      />
    </Modal>
  )
}

export default Popup
